<template>
    <div class="taskAdd">
        <Head-view :showStyle="6"></Head-view>
        <div class="main">
            <div class="breadcrumb" @click="backClose">
                异常记录 &nbsp;/&nbsp;
                <span style="color: rgba(132, 133, 135, 1)">{{
                    editTitle
                }}</span>
            </div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="addBoxTop">
                        <div class="addBoxLeft">
                            <div class="instMsg fontSize">巡检任务详情</div>
                            <div class="commRowstyle instMsg">
                                <div class="inpTitle">任务名称:</div>
                                <div
                                    class="inpFrom"
                                    
                                >
                                    {{ inspectionObj.taskName }}&nbsp;
                                    <span v-if="inspectionObj.frequency">({{ inspectionObj.frequency }})</span>
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">巡检员:</div>
                                <div
                                    class="inpFrom"
                                >
                                    {{ inspectionObj.staffName }}&nbsp;
                                    <span v-if="inspectionObj.staffDept">({{ inspectionObj.staffDept }})</span>
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">巡检时间:</div>
                                <div class="inpFrom">
                                    <a v-if="inspeStatus == 4">暂无</a>
                                    <a v-if="inspeStatus != 4">{{ inspectionObj.inspectStartTime }}</a>
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">巡检时长:</div>
                                <div class="inpFrom">
                                    <a class="inpFromA">
                                        {{ inspectionObj.duration }}
                                        <i :class="[inspectionObj.isTimeout ? 'timeout' : '']"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">计划巡检时间:</div>
                                <div class="inpFrom">
                                    {{ inspectionObj.inspectPlanTime }}
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">路线名称:</div>
                                <div class="inpFrom">
                                    {{ inspectionObj.routeName }}
                                </div>
                            </div>
                        </div>

                        <div class="addBoxRight">
                            <div class="addBoxRightStart">
                                <img
                                    v-if="inspectionObj.status == 2"
                                    src="../../../assets/inspection/success.png"
                                    alt=""
                                />
                                <img
                                    v-if="inspectionObj.status == 3"
                                    src="../../../assets/inspection/error.png"
                                    alt="异常完成"
                                />

                                <img 
                                    v-if="inspectionObj.status == 4"
                                    src="../../../assets/inspection/omissionSpince.png" 
                                    alt="漏检"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="addBoxBottom">
                        <div class="commRowstyle marginTop_20 instMsg">
                            <div class="inpTitle">路线图片:</div>
                            <div class="inpFrom routerImg">
                                <img v-if="inspectionObj.routePicture" :src="inspectionObj.routePicture" alt="" />
                                <img v-if="!inspectionObj.routePicture" src="../../../assets/routerDefaultImg3x.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="routerMsgBox">
                    <div class="routerName">巡检轨迹</div>
                    <div class="routerMenu">
                        <div
                            class="menuSelect"
                            v-for="(item, key) in inspectionObj.placeList"
                            :key="key"
                        >
                            <div class="menuNumLeft">
                                <div class="menuNum">{{ key + 1 }}</div>
                            </div>
                            <div class="menuNumMsgRight">
                                <div class="menuMsgImg_1">
                                    <div class="imgSopt">
                                        <img v-if="item.placePicture" :src="item.placePicture" alt="" />
                                        <img v-if="!item.placePicture" src="../../../assets/placeDefaultImg.png" alt="" />
                                    </div>
                                    <div class="fontSopt">
                                        <div class="sortName">
                                            {{ item.placeName }}
                                        </div>
                                        <div class="inspectionStatus">
                                            <span class="titles"
                                                >巡检状态:</span
                                            >
                                            &nbsp;&nbsp;
                                            <span
                                                class="fonts fontSuccessColor"
                                                v-if="item.status == 1"
                                                >正常</span
                                            >
                                            <span
                                                class="font fontErrorColor"
                                                v-if="item.status == 2"
                                                >异常
                                            </span>
                                        </div>
                                        <div class="inspectionTime">
                                            <span class="titles"
                                                >巡检时间:</span
                                            >
                                            &nbsp;&nbsp;
                                            <span class="fonts">{{
                                                item.inspectTime
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="seeInspectionMsgBtn">
                                        <div
                                            class="seeBtn"
                                            @click="seeInspecMsg(item)"
                                        >
                                            查看巡检要求
                                        </div>
                                    </div>
                                </div>
                                <div class="menuMsgImg_2">
                                    <div
                                        class="menuMsgChild"
                                        v-for="(inspVal, index) in item.result"
                                        :key="index"
                                    >
                                        <div class="fontTitle">
                                            <div class="fontNum">
                                                {{ index + 1 }}
                                            </div>
                                            <div class="fontDisp">
                                                {{ inspVal.name }}
                                            </div>
                                            <div class="fontStatus">
                                                <img
                                                    v-if="inspVal.status == 1"
                                                    src="../../../assets/inspection/successIco.png"
                                                    alt=""
                                                />
                                                <img
                                                    v-if="
                                                        !(inspVal.status == 1)
                                                    "
                                                    src="../../../assets/inspection/errorIco.png"
                                                    alt=""
                                                />
                                            </div>
                                        </div>

                                        <div class="routerMsgImg" v-if="inspVal.picList && inspVal.picList.length > 0">
                                            <div
                                                class="imgMsg"
                                                v-for="(
                                                    imgItem, imgKey
                                                ) in inspVal.picList"
                                                :key="imgKey"
                                            >
                                                <el-image
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="imgItem"
                                                    :preview-src-list="
                                                        inspVal.picList
                                                    "
                                                >
                                                </el-image>
                                            </div>
                                        </div>
                                        <div class="fontDispMsg">
                                            {{ inspVal.text }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="巡检要求" :visible.sync="dialogTableVisible">
            <el-table
                :data="gridData"
                stripe
                style="width: 100%"
                height="350"
                :header-cell-style="{
                    backgroundColor: 'rgba(246, 245, 245, 1)',
                    height: '56px',
                }"
            >
                <el-table-column prop="name" label="标题" width="200">
                </el-table-column>
                <el-table-column prop="description" label="描述" width="338">
                </el-table-column>
                <el-table-column width="200" label="反馈">
                    <template slot-scope="scope">
                        <div class="status">
                            状态<span v-if="scope.row.need_text">/文字</span
                            ><span v-if="scope.row.need_picture">/图片</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "taskAdd",
    data() {
        return {
            insId: "",
            editTitle: "异常记录详情",
            inspeStatus: 0,
            inspectionObj: {},

            gridData: [],
            dialogTableVisible: false,
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))
        this.taskInspectRecordId = this.$route.query.id;
        this.inspectionMsgInfo(this.$route.query.id);
    },

    methods: {
        inspectionMsgInfo(id) {
            let data = {
                token: this.getCookie(),
                taskInspectRecordId: id,
            };
            this.request
                .post(this.baseUrl + "inspect/getTaskInspectRecordDetail", data)
                .then((res) => {
                    if (res.code == 0) {
                        let dataArr = res.data;
                        res.data.placeList.forEach((item, key) => {
                            let resultObj = JSON.parse(item.result);
                            dataArr.placeList[key]["result"] = resultObj;
                        });
                        this.inspectionObj = dataArr;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "出错了:" + err,
                    });
                });
        },

        seeInspecMsg(val) {
            this.dialogTableVisible = true;
            this.gridData = val.result;
        },

        backClose() {
            this.$router.replace("/abnormal");
        },
    },
};
</script>

<style lang="less" scoped>
.taskAdd {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        overflow: hidden;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            cursor: pointer;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        padding: 24px 0 0 24px;
        width: 730px;

        .addBoxTop {
            display: flex;
            flex-direction: row;
        }

        .addBoxBottom {
            display: flex;
            flex-direction: row;
        }

        .addBoxLeft {
            width: 422px;
        }

        .addBoxRight {
            height: 200px;
            .addBoxRightStart {
                margin-left: 36px;
                margin-top: 19px;
            }
        }

        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .fontSize {
            font-size: 18px;
        }

        .userNum {
            line-height: 40px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
        }

        .commRowstyle {
            margin-top: 12px;
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 138px;
                color: rgba(84, 85, 86, 1);
                font-size: 16px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;
                color: rgba(0, 0, 0, 1);

                .inpFromA {
                    position: relative;
                }

                span {
                    font-size: 13px;
                    font-weight: 400;
                    color: rgba(166, 166, 166, 1);
                }
            }

            .routerImg {
                width: 388px;
                height: 388px;
                overflow: hidden;
                img {
                    width: 100%;
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }

            .timeout {
                position: absolute;
                top: 1.5px;
                right: -40px;
                display: block;
                width: 36px;
                height: 18px;
                background: url('../../../assets/inspection/timeout.png') no-repeat center center;
                background-size: 36px 18px;
            }
        }

        .marginTop_20 {
            margin-top: 20px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .checkedDate {
            margin-top: 13px;
            line-height: 40px;

            .checkedOne {
                width: 125px;
            }

            .checkedMon {
                width: 231px;
            }

            /deep/ .el-input__inner {
                width: 86px;
            }

            .checkedDay {
                width: 262px;
                /deep/ .el-input__inner {
                    width: 153px;
                }
            }

            .textarea {
                width: 493px;
            }
        }

        .tip {
            padding-top: 21px;
            padding-left: 15px;
            color: rgba(144, 147, 153, 1);
            font-size: 13px;
            height: 19px;
            font-weight: 400;
            text-align: left;
        }

        .userNumber {
            padding-bottom: 10px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
            font-weight: 500;
        }

        .tipBox {
            padding-left: 15px;

            > .tip {
                padding: 0;
                padding-top: 1px;
            }
        }
    }

    .routerMsgBox {
        margin: 24px 0 0 0;
        width: 527px;
        background: rgba(255, 255, 255, 1);

        .routerName {
            color: rgba(48, 49, 51, 1);
            text-align: left;
            font-size: 16px;
        }

        .routerList {
            margin-top: 20px;
        }

        .routerMenu {
            margin-top: 22px;
            width: 100%;
            height: 90%;
            overflow-y: auto;

            .menuSelect {
                display: flex;
                flex-direction: row;
                height: auto;
                .menuNumLeft {
                    width: 56px;
                    height: 100%;
                    .menuNum {
                        margin-top: 25px;
                        width: 24px;
                        height: 24px;
                        line-height: 24px;
                        opacity: 0.7;
                        border-radius: 45px;
                        text-align: center;
                        font-size: 14px;
                        color: #fff;
                        background: rgba(25, 137, 250, 1);
                    }
                }

                .menuNumMsgRight {
                    width: 471px;
                    height: auto;

                    .menuMsgImg_1 {
                        display: flex;
                        flex-direction: row;
                        width: 471px;

                        .seeInspectionMsgBtn {
                            width: 173px;
                            .seeBtn {
                                margin-top: 22px;
                                float: right;
                                width: 115px;
                                height: 32px;
                                background: rgba(4, 134, 254, 1);
                                color: #fff;
                                font-size: 14px;
                                text-align: center;
                                font-weight: 500;
                                line-height: 32px;
                                border-radius: 4px;
                                cursor: pointer;
                            }
                        }
                    }

                    .menuMsgImg_2 {
                        margin-top: 19px;
                        width: 100%;
                        .menuMsgChild {
                            width: 100%;

                            .routerMsgImg {
                                height: 82px;
                            }
                        }
                        .fontTitle {
                            display: flex;
                            flex-direction: row;
                            .fontNum {
                                width: 17px;
                                height: 17px;
                                text-align: center;
                                font-size: 12px;
                                line-height: 17px;
                                border-radius: 45px;
                                border: 1px solid rgba(56, 56, 56, 1);
                            }

                            .fontDisp {
                                margin-left: 10px;
                                max-width: 300px;
                                font-size: 12px;
                                line-height: 20px;
                                font-weight: 400;
                                color: rgba(56, 56, 56, 1);
                                text-align: left;
                            }

                            .fontStatus {
                                margin-left: 15px;
                            }
                        }

                        .routerMsgImg {
                            margin-top: 11px;
                            width: 100%;
                            height: 82px;
                            overflow-y: auto;

                            .imgMsg {
                                margin-left: 15px;
                                float: left;
                                width: 82px;
                                height: 82px;
                                overflow: hidden;
                                img {
                                    width: 100%;
                                }
                            }

                            .marginLeft_15 {
                                margin-left: 15px;
                            }

                            .marginTop_8 {
                                margin-top: 8px;
                            }
                        }

                        .fontDispMsg {
                            margin-top: 5px;
                            margin-bottom: 10px;
                            width: 100%;
                            font-size: 12px;
                            font-weight: 400;
                            color: rgba(128, 128, 128, 1);
                            text-align: left;
                        }
                    }
                }

                .imgSopt {
                    width: 78px;
                    height: 78px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }

                .fontSopt {
                    margin-left: 20px;
                    width: 200px;
                    .sortName {
                        font-size: 20px;
                        font-weight: 500;
                    }

                    .titles {
                        font-size: 12px;
                        font-weight: 400;
                        color: rgba(84, 85, 86, 1);
                        text-align: right;
                    }

                    .fonts {
                        font-size: 12px;
                        font-weight: 400;
                        text-align: left;
                    }

                    .fontSuccessColor {
                        color: rgba(33, 199, 159, 1);
                    }

                    .fontErrorColor {
                        color: rgba(255, 87, 51, 1);
                    }
                }
            }

            .marginTop_21 {
                margin-top: 21px;
            }
        }
    }

    .foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 71px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;

        .btn {
            float: right;
            display: flex;
            flex-direction: row;
            padding-top: 15.5px;
            padding-right: 56px;
            .commBtn {
                width: 95px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .successBtn {
                color: rgba(255, 255, 255, 1);
                background: rgba(103, 194, 58, 1);
            }

            .closeBtn {
                margin-right: 24px;
                color: rgba(96, 98, 102, 1);
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(220, 223, 230, 1);
            }
        }
    }
}
</style>